































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { MapLegend } from '~/models'
import IconButton from '~/components/shared/buttons/IconButton.vue'

@Component({
  components: {
    IconButton,
  },
})
export default class MapLegends extends Vue {
  @Prop({ default: (): Array<MapLegend> => [] }) legends: Array<MapLegend>
  @Prop({ default: true }) legendOpened: boolean
  legendOpen: boolean = true

  constructor() {
    super()
    this.legendOpen = this.legendOpened
  }

  onInfoClicked() {
    this.legendOpen = !this.legendOpen
  }
}
